const BODY_CATEGORIES = /body|bumper|headlight|fender|door|bonnet|hood|mirror|grille|tail\s*light/i;

/**
 * Resolve PDP path for catalog / search listings.
 * Body used parts → B-06 (/catalog/body-p-:id)
 * Other used parts → B-05 (/catalog/used-p-:id)
 * New OEM / Aftermarket → B-04 (/catalog/part-p-:id)
 */
export function isUsedListing(product = {}) {
  const cond = String(product.condition || product.listingType || '').toLowerCase();
  const partType = String(product.partType || '').toUpperCase();
  return cond === 'used' || partType === 'USED';
}

export function isBodyPartListing(product = {}) {
  if (!isUsedListing(product)) return false;
  const cat = `${product.category || ''} ${product.subCategory || ''} ${product.name || ''}`;
  return BODY_CATEGORIES.test(cat) || product.isBodyPart === true || product.listingType === 'body';
}

export function getPartDetailPath(product, { categorySlug } = {}) {
  const id = product?.id || product?._id || product?.listingId;
  if (!id) return '/catalog';

  if (categorySlug === 'timing_belt' || categorySlug === '4390-timing_belt') {
    return `/catalog/timing-belt/${id}`;
  }

  if (isBodyPartListing(product)) {
    return `/catalog/body-p-${id}`;
  }

  if (isUsedListing(product)) {
    return `/catalog/used-p-${id}`;
  }

  return `/catalog/part-p-${id}`;
}

export function isUsedConditionKey(condition) {
  const c = String(condition || '').toLowerCase();
  return c === 'used' || c.startsWith('used_');
}

/**
 * PDP link from catalog node listing cards (preserves vehicle + node context).
 */
export function buildCatalogNodeListingPath(
  listing,
  { vehicleId, catalogNodeId, condition } = {}
) {
  const id = listing?.listingId || listing?.id || listing?._id;
  if (!id) return '/catalog';

  const cond = condition || listing?.condition || '';
  const used = isUsedConditionKey(cond) || isUsedListing(listing);
  const base = used ? `/catalog/used-p-${id}` : `/catalog/part-p-${id}`;
  const qs = new URLSearchParams();
  if (vehicleId) qs.set('vehicleId', vehicleId);
  if (catalogNodeId) qs.set('catalogNodeId', catalogNodeId);
  if (used) qs.set('column', 'used');
  const q = qs.toString();
  return q ? `${base}?${q}` : base;
}

/**
 * Marketplace checkout URL (catalog node + single listing).
 */
export function buildMarketplaceCheckoutPath({ vehicleId, catalogNodeId, listingId }) {
  const qs = new URLSearchParams();
  if (vehicleId) qs.set('vehicleId', vehicleId);
  qs.set('catalogNodeId', catalogNodeId);
  qs.set('listingId', listingId);
  return `/checkout?${qs.toString()}`;
}
